// extracted by mini-css-extract-plugin
module.exports = {"head":"styles_head__BpuMv","mobileCard":"styles_mobileCard__sSRg0","heading":"styles_heading__vk4wV","group":"styles_group__BUY8I","orgs-wrapper":"styles_orgs-wrapper__aGyZt"};